var $52e8b1b00094e5a3$exports = {};
$52e8b1b00094e5a3$exports = {
  "close": "\u95DC\u9589",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \u500B\u901A\u77E5");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \u500B\u901A\u77E5");
      }
    }), "\u3002");
  }
};
export { $52e8b1b00094e5a3$exports as default };